var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16699 16C5.16699 15.1716 5.83857 14.5 6.66699 14.5H25.3337C26.1621 14.5 26.8337 15.1716 26.8337 16C26.8337 16.8284 26.1621 17.5 25.3337 17.5H6.66699C5.83857 17.5 5.16699 16.8284 5.16699 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqMinus);
export default __webpack_public_path__ + "static/media/faq_minus.f8f2279c712989e4a1a0cb3bce2b2282.svg";
export { ForwardRef as ReactComponent };